import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Chart_Interface } from 'src/app/Interface/Chart_Interface';

@Component({
  selector: 'app-Chart_Check_Co',
  templateUrl: './Chart_Check_Co.component.html',
  styleUrls: ['./Chart_Check_Co.component.css']
})
export class Chart_Check_CoComponent implements OnInit {

  @Input() inner_Chart: Array<Chart_Interface> = []
  @Output() On_Change_Action = new EventEmitter<Chart_Interface>();


  constructor() { }

  ngOnInit() {
  }

  Change_Visible(item: Chart_Interface) {
    this.On_Change_Action.emit(item);
  }

}
